import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useReport } from "@utils/useReports";
import { wsBaseUrl } from "@utils/baseValues";
import { removeProgressEntry } from "./reportProgressUtils";
import { useAppContext } from "@shared/context/AppContext";
interface UseReportGenerationWebSocketOptions {
  taskId: string;
}

export const useReportGenerationWebSocket = ({
  taskId,
}: UseReportGenerationWebSocketOptions) => {
  const { projectId, taskId: query_task_id } = useParams();
  const [reportStatus, setReportStatus] = useState<string>("");
  const [progressMessage, setProgressMessage] = useState<string>("");
  const [onProcessing, setOnProcessing] = useState(false);
  const [reportId, setReportId] = useState<number>(-1);

  const { handleTriggerTasksRefresh } = useAppContext();

  const navigate = useNavigate();
  const { getReportById } = useReport();

  useEffect(() => {
    if (taskId === "" || taskId === "null") return;

    const ws = new WebSocket(`${wsBaseUrl}/task/${taskId}`);

    ws.onmessage = async (event) => {
      handleTriggerTasksRefresh();
      const message = JSON.parse(event.data);
      setReportStatus(message.state);
      if (message.state === "SUCCESS") {
        if (!isNaN(parseInt(JSON.parse(message.result), 10))) {
          const newReportId = parseInt(JSON.parse(message.result), 10);
          try {
            setReportId(newReportId);
            if (projectId) {
              const report = await getReportById(projectId, newReportId);
              if (report && projectId && query_task_id) {
                removeProgressEntry(query_task_id);
                navigate(`/report/${newReportId}/project/${projectId}`);
              }
            }
          } catch (error) {
            console.error("Error fetching report:", error);
          }
        }
      } else if (message.state === "PROGRESS" || message.state === "PENDING") {
        setProgressMessage(message.current_step || "");
      } else if (message === "None" || message.state === "FAILURE") {
        setReportStatus("FAILURE");
      }
    };

    ws.onclose = () => {
      console.log("WebSocket closed");
    };

    return () => {
      ws.close();
    };
  }, [taskId, projectId]);

  useEffect(() => {
    const match = location.pathname.match(
      /^\/project\/([^/]+)\/report-creation\/([^/]+)$/
    );

    if (match) {
      setOnProcessing(true);
    } else {
      setOnProcessing(false);
    }
  }, [location.pathname, navigate]);

  return {
    reportStatus,
    setProgressMessage,
    progressMessage,
    reportId,
  };
};
